'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavigationButton = require('./components/NavigationButton');

var _NavigationButton2 = _interopRequireDefault(_NavigationButton);

var _Display = require('./components/Display');

var _Display2 = _interopRequireDefault(_Display);

var _Indicators = require('./components/Indicators');

var _Indicators2 = _interopRequireDefault(_Indicators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel() {
    _classCallCheck(this, Carousel);

    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this));

    _this.state = { currentIndex: 0 };
    _this.autoScrollTimer = undefined;
    _this.changeItem = _this.changeItem.bind(_this);
    _this.setCurrentIndex = _this.setCurrentIndex.bind(_this);
    return _this;
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          autoScroll = _props.autoScroll,
          autoScrollTime = _props.autoScrollTime;

      autoScroll && (this.autoScrollTimer = setInterval(function () {
        return _this2.changeItem('right');
      }, autoScrollTime));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.autoScrollTimer !== undefined && clearInterval(this.autoScrollTimer);
    }
  }, {
    key: 'setCurrentIndex',
    value: function setCurrentIndex(currentIndex) {
      this.setState({ currentIndex: currentIndex });
    }
  }, {
    key: 'changeItem',
    value: function changeItem(direction) {
      var currentIndex = this.state.currentIndex;
      var length = this.props.children.length;

      if (direction === 'left') {
        this.setCurrentIndex(currentIndex === 0 ? length - 1 : currentIndex - 1);
      }
      if (direction === 'right') {
        this.setCurrentIndex(currentIndex === length - 1 ? 0 : currentIndex + 1);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var currentIndex = this.state.currentIndex;
      var _props2 = this.props,
          children = _props2.children,
          color = _props2.color,
          width = _props2.width,
          displayItems = _props2.displayItems,
          disable = _props2.disable;
      // Concatenate 3 children arrays to easily slice adjacent items to be displayed.

      var clonedChildren = [].concat(_toConsumableArray(children), _toConsumableArray(children), _toConsumableArray(children));
      var newIndex = currentIndex + children.length + 1;
      var itemsToDisplay = clonedChildren.slice(newIndex - displayItems / 2, newIndex + displayItems / 2);
      return _react2.default.createElement(
        'div',
        { style: { width: width } },
        _react2.default.createElement(
          'div',
          { className: 'carousel-main-container' },
          !(disable === 'nav' || disable === 'both') && _react2.default.createElement(_NavigationButton2.default, { direction: 'left', color: color, onClick: function onClick() {
              return _this3.changeItem('left');
            } }),
          _react2.default.createElement(_Display2.default, { display: itemsToDisplay }),
          !(disable === 'nav' || disable === 'both') && _react2.default.createElement(_NavigationButton2.default, { direction: 'right', color: color, onClick: function onClick() {
              return _this3.changeItem('right');
            } })
        ),
        !(disable === 'indicators' || disable === 'both') && _react2.default.createElement(_Indicators2.default, { items: children, index: currentIndex, setIndex: this.setCurrentIndex, color: color })
      );
    }
  }]);

  return Carousel;
}(_react2.default.Component);

exports.default = Carousel;


Carousel.propTypes = {
  autoScroll: _propTypes2.default.bool,
  autoScrollTime: _propTypes2.default.number,
  color: _propTypes2.default.string,
  width: _propTypes2.default.string,
  displayItems: _propTypes2.default.number,
  disable: _propTypes2.default.oneOf(['nav', 'indicators', 'both', 'none'])
};

Carousel.defaultProps = {
  autoScroll: false,
  autoScrollTime: 3000,
  color: 'black',
  width: '100%',
  displayItems: 3,
  disable: 'none'
};


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/molecules/Carousel/Carousel.js
// module id = 476
// module chunks = 168707334958949